import { render, staticRenderFns } from "./authSSO.vue?vue&type=template&id=69b131f6&scoped=true&"
import script from "./authSSO.vue?vue&type=script&lang=js&"
export * from "./authSSO.vue?vue&type=script&lang=js&"
import style0 from "./authSSO.vue?vue&type=style&index=0&id=69b131f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b131f6",
  null
  
)

export default component.exports